/**
 * Lead/Customer Management API Service
 * Handles all API calls for lead/customer management functionality
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * Get common headers for all API requests
 * @returns {Object} Headers object
 */
const getCommonHeaders = () => ({
  'Content-Type': 'application/json',
  'apiKey': process.env.REACT_APP_API_KEY || '',
  'lang': process.env.REACT_APP_LANG || 'en-US',
  'Authorization': process.env.REACT_APP_AUTHORIZATION || '',
  'db': process.env.REACT_APP_DB || '',
  'baseDb': process.env.REACT_APP_BASE_DB || '',
  'companyId': process.env.REACT_APP_COMPANY_ID || '',
  'companyNo': process.env.REACT_APP_COMPANY_NO || '',
});

/**
 * Fetch customer data with pagination, sorting, and filtering
 * @param {Object} params - Query parameters
 * @returns {Promise} Response data
 */
export const getCustomerData = async (params) => {
  try {
    const url = `${API_BASE_URL}/leads/get-list`;
    console.log('Fetching from:', url);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: getCommonHeaders(),
      body: JSON.stringify(params),
    });
console.log('Response status:', response);
    if (!response.ok) {
      const contentType = response.headers.get('content-type');
      let errorMessage = `HTTP error! status: ${response.status}`;
      
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } else {
        const text = await response.text();
        console.error('Non-JSON response:', text.substring(0, 200));
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    console.log('Fetched data:', data.data.data);
    return data.data;
  } catch (error) {
    console.error('Error fetching customer data:', error);
    throw error;
  }
};

/**
 * Edit a customer record
 * @param {number} id - Customer ID
 * @returns {Promise} Response
 */
export const editCustomer = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/EditClient`, {
      method: 'POST',
      headers: getCommonHeaders(),
      body: JSON.stringify({ id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error editing customer:', error);
    throw error;
  }
};

/**
 * View a customer record
 * @param {number} id - Customer ID
 * @returns {Promise} Response
 */
export const viewCustomer = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/ViewClient`, {
      method: 'POST',
      headers: getCommonHeaders(),
      body: JSON.stringify({ id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error viewing customer:', error);
    throw error;
  }
};

/**
 * Delete a customer record
 * @param {number} id - Customer ID
 * @returns {Promise} Response
 */
export const deleteCustomer = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/DeleteClient`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error deleting customer:', error);
    throw error;
  }
};

export default {
  getCustomerData,
  editCustomer,
  viewCustomer,
  deleteCustomer,
};
